import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AppHeader from './AppHeader';

export default function About() {
  const theme = useTheme();
  return (


    <Box
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: '#3B4E68',
        display: 'flex',
        flexDirection: 'column',
        // justifyContent: 'space-between',
        paddingBottom: '20px',
      }}
    >

      <Box>
        <AppHeader />
      </Box>


      <Typography
        variant='body1'
        sx={{
          color: '#FFFFFF',
          fontSize: '24px',
          fontWeight: 'bold',
          textAlign: 'left',
          paddingLeft: '20px',
        }}
      >
        About
      </Typography>

      <Box
        sx={{
          color: '#FFFFFF',
          textAlign: 'left',
          fontSize: '14px',
          // paddingRight: '10px',
          padding: '20px',
        }}
      >
        Gridvault offers a revolutionary knowledge-factor authentication method using easy-to-remember patterns to extract one-time codes from a grid.
        The essence of this technology is that the user’s secret is never revealed, hence cannot be captured,
        and the user must actively participate in the authentication process (as opposed to passive biometric authentication).
      </Box>
      <Box
        sx={{
          color: '#FFFFFF',
          textAlign: 'left',
          fontSize: '14px',
          // paddingRight: '10px',
          padding: '20px',
        }}
      >
        Combined with FIDO2 technology, Gridvault becomes a highly secure and compliant 2FA solution to provide 'right-person-present' authentication.
        Users interact with a secret pattern on the grid to generate a hidden one-time passcode.
        This ensures that authentication can only occur through active, user-specific input that is never disclosed or shared.
      </Box>
      <Box
        sx={{
          color: '#FFFFFF',
          textAlign: 'left',
          fontSize: '14px',
          // paddingRight: '10px',
          padding: '20px',
        }}
      >
        Gridvault offers a cutting-edge, secure authentication process where the user’s active participation guarantees they are present,
        providing an unmatched level of assurance for compliance and security, especially in high-risk environments.
      </Box>
    </Box>

  );
}